import i18n from '../../localization';

export enum DischargeType {
    Automated,
    Manual,
}

export enum Shape {
    Straight,
    Curved,
}

export enum SideOrientation {
    Left,
    Right,
}

export const DischargeTypeMapLabel = () => ({
    [DischargeType.Automated]: i18n.t('hydraulic_data_automated_discharge'),
    [DischargeType.Manual]: i18n.t('tab_results_discharge'),
});
